export const CustomRoles = {
    Admin: 'canAdmin',
    Teacher: 'canTeach',
    TrafficManager: "canTrafficManage",
    ContentManager: "canContentManage",
    CustomerSupport: "canCustomerSupport",
    LiveOperations: "canLiveOps",
    QA: "canQA"
}